import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';

import { IModalComponentName, ModalComponent } from '../components/modal/modal.component';
import { IModalConfirmOptions } from '../components/modal/modal-content-confirm/modal-content-confirm.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private currentModal?: MatDialogRef<ModalComponent>;

  constructor(private readonly dialog: MatDialog) {}

  public launchResponsiveModal(
    component: IModalComponentName,
    customModalData?: any,
    config?: MatDialogConfig,
  ): MatDialogRef<ModalComponent> {
    this.currentModal = this.dialog.open(ModalComponent, {
      ...config,
      data: { component, data: customModalData },
    });

    this.currentModal.afterClosed().subscribe({
      next: () => {
        this.currentModal = undefined;
      },
      error: (err) => {
        console.error('Error occurred while closing modal:', err);
      },
    });

    return this.currentModal;
  }

  public changeCurrentlyOpenModalComponent(component: IModalComponentName, data?: any): void {
    if (this.currentModal == null) {
      console.error('No modal is currently open');
    } else {
      this.currentModal.componentInstance.data = { component, data };
    }
  }

  public async launchConfirmModal(customModalData: IModalConfirmOptions): Promise<boolean> {
    return lastValueFrom(this.launchResponsiveModal('confirm', customModalData).afterClosed());
  }
}
